var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"jee-log",attrs:{"title":_vm.title,"visible":_vm.showLog,"width":_vm.width,"before-close":_vm.dialogClose},on:{"update:visible":function($event){_vm.showLog=$event}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }